module.exports = __webpack_public_path__ + "img/tubiao.31741565.svg";